import React from 'react';

import QuickView from '../block-content/quick-view.js';
import StatModule from '../block-content/stat-module.js';
import TechSpecs from '../block-content/tech-specs.js';
import SlideshowModule from '../block-content/slideshow-module.js';
import Hero from '../block-content/hero.js';
import ContactModule from '../block-content/contact-module.js';
import ColumnBlock from '../block-content/column-block.js';
import List from '../block-content/list.js';
import InlineImage from '../block-content/inline-image.js';
import SplitImage from '../block-content/split-image.js';
import InlineVideo from '../block-content/inline-video.js';

const BlockContent = (item, embedded = false) => {
  switch (item.nodeType) {
    case 'paragraph':
      return (
        <div key={Math.random()} className="article__text">
          <div className={embedded ? 'al' : 'container--xl ma al px15'}>
            <p>
              {item.content.map(content => {
                if (content.nodeType === 'hyperlink') {
                  return (
                    <a
                      key={Math.random()}
                      href={content.data.uri}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {content.content[0].value}
                    </a>
                  );
                }
                if (content.marks && content.marks.length >= 1) {
                  if (content.marks[0].type === 'italic') {
                    return <em>{content.value}</em>;
                  } else if (content.marks[0].type === 'bold') {
                    return <b>{content.value}</b>;
                  } else if (content.marks[0].type === 'code') {
                    if (content.value.indexOf('iframe') > -1) {
                      return (
                        <div key={Math.random()} className="article__text-video">
                          <div dangerouslySetInnerHTML={{ __html: content.value }} />
                        </div>
                      );
                    } else if (content.value.indexOf('blockquote') > -1) {
                      return (
                        <div key={Math.random()} className="article__twitter">
                          <div dangerouslySetInnerHTML={{ __html: content.value }} />
                        </div>
                      );
                    } else {
                      return (
                        <div
                          className="article__quote"
                          key={Math.random()}
                          dangerouslySetInnerHTML={{ __html: content.value }}
                        />
                      );
                    }
                  } else {
                    return (
                      <span
                        key={Math.random()}
                        dangerouslySetInnerHTML={{ __html: content.value }}
                      />
                    );
                  }
                } else {
                  return <span key={Math.random()}>{content.value}</span>;
                }
              })}
            </p>
          </div>
        </div>
      );
    case 'heading-1':
      return (
        <div key={Math.random()} className="container--m ma ac px15 py1">
          {item.content.map(content => (
            <h1 key={Math.random()}>{content.value}</h1>
          ))}
        </div>
      );
    case 'heading-2':
      return (
        <div key={Math.random()} className="container--xl ma px15">
          {item.content.map(content => (
            <h2 key={Math.random()}>{content.value}</h2>
          ))}
        </div>
      );
    case 'heading-3':
      return (
        <div key={Math.random()} className="container--xl ma px15">
          {item.content.map(content => (
            <h3 key={Math.random()}>{content.value}</h3>
          ))}
        </div>
      );
    case 'heading-4':
      return (
        <div key={Math.random()} className="container--xl ma px15">
          {item.content.map(content => (
            <h4 key={Math.random()}>{content.value}</h4>
          ))}
        </div>
      );
    case 'heading-5':
      return (
        <div key={Math.random()} className="container--xl ma px15">
          {item.content.map(content => (
            <h5 key={Math.random()}>{content.value}</h5>
          ))}
        </div>
      );
    case 'heading-6':
      return (
        <div key={Math.random()} className="container--xl ma px15">
          {item.content.map(content => (
            <h6 key={Math.random()}>{content.value}</h6>
          ))}
        </div>
      );
    case 'embedded-entry-block':
      if (item.data) {
        switch (item.data.target.sys.contentType.sys.id) {
          case 'heroModule':
            return <Hero key={Math.random()} item={item.data.target} />;
          case 'inlineImage':
            return (
              <InlineImage key={Math.random()} data={item.data.target.fields} />
            );
          case 'inlineVideo':
            return (
              <InlineVideo key={Math.random()} data={item.data.target.fields} />
            );
          case 'splitImage':
            return <SplitImage key={Math.random()} data={item.data.target.fields} />;
          case 'statModule':
            return <StatModule data={item.data.target.fields} key={Math.random()} />;
          case 'quickView':
            return <QuickView data={item.data.target.fields} key={Math.random()} />;
          case 'techSpecs':
            return <TechSpecs data={item.data.target.fields} key={Math.random()} />;
          case 'slideshowModule':
            return (
              <SlideshowModule data={item.data.target.fields} key={Math.random()} />
            );
          case 'contactModule':
            return <ContactModule key={Math.random()} />;
          case 'threeColumnLayout':
            return (
              <ColumnBlock key={Math.random()} data={item.data.target.fields} />
            );
          case 'list':
            return <List key={Math.random()} data={item.data.target.fields} />;
          default:
            break;
        }
      }
      break;
    default:
      return <div key={Math.random()} />;
  }
};

export default BlockContent;
